<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    @close="$emit('handleCloseModal')"
    :title="$t('common.PrivacyPolicy')"
  >
    <div v-if="$store.state.language === 'zh'" class="content">
      <h1 class="h1_text">隐私政策</h1>
      <br />
      <div style="margin: 0px; font-family: 宋体; font-size: 14px">
        版本日期：2021年 7 月 26 日
        <br />
        <br />
        在辛格迪，隐私是重中之重。本隐私政策规定了辛格迪如何从访问或使用我们的客户和其他个人（统称为“您”）那里收集和使用个人信息网站，包括我们的移动应用程序、我们的网络客户端或专业客户端，和/或链接到本隐私声明的任何其他网站、产品或服务（“服务”）。通过使用我们的服务，您了解我们将按照本隐私政策中的描述收集和使用您的个人信息。
        <br />
        我们建议您完整阅读本隐私政策，以确保您完全了解情况。但是，如果您想访问本隐私政策的某个部分，请参阅下表。
        <br />
        <br />
        <!-- <ul class="maoLink">
          <li>我们如何收集个人信息</li>
          <li>个人信息的使用</li>
          <li>个人信息共享</li>
          <li>个人信息的保留</li>
          <li>您的选择</li>
          <li>儿童隐私</li>
          <li>您的隐私权</li>
          <li>我们如何保护您的个人信息</li>
          <li>本政策的变更</li>
          <li>如何联系我们</li>
        </ul> -->

        <h2 class="h2_text">1.我们如何收集个人信息</h2>
        <br />
        <br />
        您可以选择是否访问我们的网站来向我们提供个人信息。但是，如果您不向我们提供某些个人信息，您可能无法使用我们服务的某些部分。例如，如果您不采用电子签名，则您将无法在我们的服务上签署某些电子文件。有关您可能拥有的选择和权利，请参阅本隐私政策的第
        5 节和第 7 节。
        <br />
        <br />
        我们从您那里收集的个人信息。  您在以下情况下向我们提供有关您自己的个人信息：
        <br />
        <br />
        <ul class="disc_ul">
          <li>注册或登录您的帐户</li>
          <li>开始、签署或查看电子文档</li>
          <li>创建或编辑您的用户个人资料</li>
        </ul>
        您提供的个人信息为身份信息、电子邮件地址、电话号码或电子签名。
        <br />
        <br />
        我们自动收集的个人信息。当您在登录使用我们的服务时，我们收集有关您用来访问我们的服务的计算机或其他设备（例如手机或平板电脑）的IP地址信息。
        <br />
        <br />
        我们从其他来源收集的信息。我们可能会从他人那里收集有关您的个人信息，例如：
        <br />
        <br />
        <ul class="disc_ul">
          <li>
            第三方来源。第三方来源的示例包括微信服务提供商以及法律允许他们与我们共享您的个人信息的其他人。例如，如果您在另一个网站上注册我们的服务，该网站可能会向我们提供您的个人信息。
          </li>
          <li>
            其他客户。其他客户可能会向我们提供您的个人信息。例如，如果客户希望您在我们的服务中签署电子文件，他或她将向我们提供您的手机号、电子邮件地址和姓名。
          </li>
          <li>
            结合来自不同来源的个人信息。我们可能会将我们从其他来源收到的个人信息与我们从您（或您的设备）收集的个人信息结合起来，并按照本隐私政策中的说明使用这些信息。
          </li>
        </ul>
        我们代表客户收集和处理的个人信息。当我们的商业客户使用某些服务时，我们通常作为数据处理者代表他们处理和存储某些个人信息。例如，在辛格迪产品的电子操作签名中，当客户上传合同或其他文件以供审核或签名时，我们充当数据处理者并代表客户并按照他们的指示处理文件。在这些情况下，客户是数据控制者，负责个人信息处理的大部分方面。如果您对在这些情况下如何处理个人信息有任何疑问或疑虑，包括如何行使您作为数据主体的权利，您应该联系客户（您的雇主或要求您签名的个人）。
        <br />
        <br />
        我们可能会按照第 3 节个人信息共享中的规定与第三方共享您的个人信息。
        <br />
        <br />

        <h2 class="h2_text">2.个人信息的使用</h2>
        <br />
        <br />
        一般而言，我们收集、使用、存储和处理您的个人信息以提供我们的服务、修复和改进它们、开发新服务及其产品和服务。以下是我们如何使用我们处理的个人信息的一些示例：
        <br />
        <br />
        <ul class="disc_ul">
          <li>创建您的帐户并管理您与我们的关系</li>
          <li>向您发送我们关系的记录，包括购买或其他活动</li>
          <li>
            记录有关电子文档发生情况的详细信息，例如谁查看或签名、使用的设备以及这些事件发生的时间
          </li>
          <li>测试我们服务中的变化并开发新功能和产品</li>
          <li>
            解决您在使用我们的服务时可能遇到的问题，包括回答支持问题和解决争议
          </li>
          <li>管理服务平台，包括支持系统和安全</li>
          <li>
            预防、调查和应对：欺诈、未经授权访问或使用我们的服务、违反条款和政策或其他不当行为
          </li>
          <li>遵守法律义务</li>
          <li>满足法定保留期限</li>
        </ul>
        如果您对我们收集和使用您的个人信息的合法依据有疑问或需要更多信息，请使用本隐私政策第
        10
        节中提供的联系方式与我们联系。请注意，在辛格迪作为处理者的情况下，由我们的客户决定适当的法律依据，并且应向他们提出查询。
        <br />
        <br />

        <h2 class="h2_text">3.个人信息共享</h2>
        <br />
        <br />
        我们不会出租、出售或与第三方共享您的个人信息，除非在本隐私政策中披露。  
        在公共或政府当局要求下，我们可能会共享您的个人信息以遵守适用法律或响应法律程序（如传票），但只有在法律强制我们这样做的情况下。当任何人的人身安全受到威胁、违反本隐私政策或其他协议，或为了保护第三方（包括我们的员工、用户或公众）的合法权利时，我们也可能会共享您的个人信息。
        <br />
        <br />
        您的个人信息也可能如下所述共享：
        <br />
        <br />
        <ul class="disc_ul">
          <li>
            其他辛格迪用户。当您允许其他人访问、使用或编辑您帐户中的内容时，我们会与他们共享该内容。例如，如果您将签署文档发送给他人以供审阅或签名，我们会将签署的内容提供给他们。
          </li>
          <li>
            公共信息。用户生成内容。当您对我们的博客或我们的社区论坛发表评论时，其他人也可能会阅读、收集和使用这些信息。
          </li>
          <li>
            您的雇主或组织。当您使用分配给您作为组织的员工、承包商或成员创建的帐户或用户角色时，该组织（如果它是辛格迪客户某些功能）可以找到您的帐户并采取某些可能会影响您的帐户的操作。
          </li>
        </ul>
        <br />

        <h2 class="h2_text">4.个人信息的保留</h2>
        <br />
        <br />
        我们保留您的个人信息的时间不会超过其处理目的所需的时间。我们保留个人信息的时间长短取决于我们收集和使用它的目的和/或遵守我们的数据保留政策和信息处理标准中规定的适用法律的要求。如果存在阻止删除或匿名化的技术限制，我们会保护个人信息并限制对其的积极使用。
        <br />
        <br />

        <h2 class="h2_text">5.您的选择</h2>
        <br />
        <br />
        本节描述了您可以采取的许多措施来更改或限制对您的个人信息的收集或使用。
        <br />
        <br />
        <ul class="disc_ul">
          <li>
            轮廓。您不需要填写个人资料。如果您这样做，您可以访问和查看这些个人信息。如果任何个人信息不准确或不完整，您可以更改您的帐户设置。
          </li>
          <li>
            Cookie 和其他相关技术。您可以通过浏览器设置中详述的其他方法拒绝
            Cookie 。但是，如果您拒绝
            cookie，您可能无法使用我们服务的某些部分。请注意，我们不识别或响应浏览器启动的“请勿跟踪”信号。
          </li>
          <li>
            投诉。我们致力于解决有关您的隐私以及我们收集或使用您的个人信息的有效投诉。有关我们的数据使用惯例或隐私政策的问题或投诉，请与我们联系。 
          </li>
        </ul>
        <br />

        <h2 class="h2_text">6.儿童隐私</h2>
        <br />
        <br />
        我们的服务不是为 16
        岁以下的人（“未成年人”）设计的，也不是针对这些人的。我们不会有意收集或索取未成年人的个人信息。我们不会故意允许未成年人使用我们的服务。如果您是未成年人，请不要使用我们的服务或向我们发送您的个人信息。我们会删除我们了解到是从未经父母同意的未成年人那里收集的个人信息。如果您认为我们可能拥有应从我们系统中删除的未成年人的个人信息或与其相关的个人信息，请通与我们联系 。
        <br />
        <br />

        <h2 class="h2_text">7.您的隐私权</h2>
        <br />
        <br />
        根据当地适用法律，您可能拥有与您的个人信息相关的某些权利。这些权利包括：
        <br />
        <br />
        <ul class="disc_ul">
          <li>您可以随时通过访问和查看与您的帐户关联的个人信息。</li>
          <li>您有权更正有关您的不准确的个人信息。</li>
          <li>
            在某些情况下，您可以要求我们删除/擦除或停止使用您的个人信息（并反对使用您的个人信息）。
          </li>
          <li>
            如果您对我们对您投诉的回应不满意，您有权随时向您当地的数据保护机构提出问题或投诉。
          </li>
        </ul>
        我们将采取合理的步骤来验证您的身份。如果您有我们的帐户，我们可能会通过您的帐户登录来验证您。您可以授权代理人代表您向我们提出请求，我们将通过寻求您的确认或证明代理人授权代表您行事的文件来验证您的代理人或授权法定代表的身份。
        <br />
        <br />
        根据适用法律，某些个人信息可能免于此类要求。我们需要某些类型的个人信息，以便我们可以向您提供产品和服务。如果您要求我们将其删除，您可能无法再访问或使用我们的产品和服务。
        <br />
        <br />

        <h2 class="h2_text">8.我们如何保护您的个人信息</h2>
        <br />
        <br />
        为确保您的个人信息安全，我们使用物理、电子和管理工具。我们根据我们收集、使用和存储的个人信息的敏感性以及当前的技术状态来应用这些工具。我们通过技术和组织安全措施保护您的个人信息，以最大限度地减少与数据丢失、滥用、未经授权的访问以及未经授权的披露和更改相关的风险。
        <br />
        <br />

        <h2 class="h2_text">9.本政策的变更</h2>
        <br />
        <br />
        我们可能会修改本隐私政策，以反映法律、我们的公司、我们的服务、我们的数据收集使用和实践或技术进步的变化。我们对收集的个人信息的使用受使用此类个人信息时有效的隐私政策的约束。根据更改的类型，我们可能会通过在此页面上发布、通知您更改。
        <br />
        <br />

        <h2 class="h2_text">10.如何联系我们</h2>
        <br />
        <br />
        有关我们使用您的个人信息或隐私政策的问题或投诉，请通过<span
          class="uni_color"
          >contact@hippocrateshealth.cn</span
        >或全国服务热线电话：400-886-2808
        与我们联系，地址：中国（上海）自由贸易试验区芳春路400号。
      </div>
    </div>
    <div v-else class="content">
      <h1 class="h1_text">Privacy Policy</h1>
      <br />
      <div style="margin: 0px; font-family: 宋体; font-size: 14px">
        Version Date:  July 26, 2021
        <br />
        <br />
        At Hippocrates, privacy is a priority. This Privacy Policy sets out how
        Hippocrates, Inc. and its group of companies (“us,” “our,” or “we”)
        collect and use personal information from customers and other
        individuals (collectively "you") who access or use our websites,
        including Hippocrateshealth.com, our mobile applications, our web client
        or professional client, and/or any of our other sites, products, or
        services that link to this Privacy Notice (the “Services”). By using our
        Services, you understand that we will collect and use your personal
        information as described in this Privacy Policy.
        <br />
        We recommend that you read this Privacy Policy in full to ensure you are
        fully informed. However, if you want to access a section of this Privacy
        Policy, please refer to the table below. 
        <br />
        <br />
        <!-- <ul class="maoLink">
          <li>How We Collect Personal Information</li>
          <li>2.Use of Personal Information</li>
          <li>Personal Information Sharing</li>
          <li>Retention of Personal Information</li>
          <li>5.Your Choices</li>
          <li>6.Children's Privacy</li>
          <li>Your Privacy Rights</li>
          <li>8.How We Protect Your Personal Information</li>
          <li>Changes to This Policy</li>
          <li>10.How to Contact Us</li>
        </ul> -->

        <h2 class="h2_text">1.How We Collect Personal Information</h2>
        <br />
        <br />
        You have choices about whether you visit our sites and provide personal
        information to us. However, if you do not provide us with certain
        personal information, you may not be able to use some parts of our
        Services. For example, if you do not adopt an electronic signature, then
        you will not be able to sign certain electronic documents on our
        Service. For choices and rights you may have, please see Sections 5 and
        7 of this Privacy Policy.
        <br />
        <br />
        Personal Information We Collect from You.  You provide us with personal
        information about yourself when you:
        <br />
        <br />
        <ul class="disc_ul">
          <li>Register or log in to your account</li>
          <li>Start, sign, or review an electronic document</li>
          <li>Create or edit your user profile</li>
        </ul>
        <br />
        <br />
        Personal Information We Collect Automatically. We automatically collect
        personal information from you and your devices when you use our
        Services. Such as mobile phones or tablets, you use to access our
        Services. For instance, IP directory.
        <br />
        <br />
        Information We Collect from Other Sources. We may collect personal
        information about you from others, such as: 
        <br />
        <br />
        <ul class="disc_ul">
          <li>
            Third-Party Sources. Examples of third-party sources include WeChat,
            service providers, and others where they are legally allowed to
            share your personal information with us. For example, if you
            register for our Services on another website, the website may
            provide your personal information to us.
          </li>
          <li>
            Other Customers. Other customers may give us your personal
            information. For example, if a customer wants you to sign an
            electronic document in our Services, he or she will give us your
            email directory and name.
          </li>
          <li>
            Combining Personal Information from Different Sources. We may
            combine the personal information we receive from other sources with
            personal information we collect from you (or your device) and use it
            as described in this Privacy Policy.
          </li>
        </ul>
        Personal Information We Collect & Process on Behalf of Customers. When
        our business customers use certain Services, we generally process and
        store certain personal information on their behalf as a data processor.
        For example, in Hippocrates Signature when a customer uploads contracts
        or other documents for review or signature, we act as a data processor
        and process the documents on the customer's behalf and in accordance
        with their instructions. In those instances, the customer is the data
        controller and is responsible for most aspects of the processing of the
        personal information. If you have any questions or concerns about how
        personal information is processed in these cases, including how to
        exercise your rights as a data subject, you should contact the customer
        (either your employer or the individual requesting your signature).
        <br />
        <br />
        We may share your personal information with third parties as provided in
        Section 3 Personal Information Sharing.
        <br />
        <br />

        <h2 class="h2_text">2.Use of Personal Information</h2>
        <br />
        <br />
        In general, we collect, use, store, and process your personal
        information to provide our Services, to fix and improve them, to develop
        new products and Services. Here are some examples of how we use the
        personal information we process:
        <br />
        <br />
        <ul class="disc_ul">
          <li>Create your account and manage your relationship with us</li>
          <li>
            Send you records of our relationship, including for purchases or
            other events
          </li>
          <li>
            Record details about what happens with electronic documents, such as
            who viewed or signed, the devices used and when these events occur
          </li>
          <li>
            Test changes in our Services and develop new features and products
          </li>
          <li>
            Fix problems you may have with our Services, including answering
            support questions and resolving disputes
          </li>
          <li>
            Manage the Services platform including support systems and security
          </li>
          <li>
            Prevent, investigate and respond to: fraud, unauthorized access to
            or use of our Services, breaches of terms and policies, or other
            wrongful behavior
          </li>
          <li>Comply with legal obligations</li>
          <li>Meet legal retention periods</li>
        </ul>
        If you have questions about or need further information concerning the
        lawful basis on which we collect and use your personal information,
        please contact us using the contact details provided in Section 10 of
        this Privacy Policy.  Note in situations where Hippocrates acts as a
        processor, it is our customer who determines the appropriate legal basis
        and queries should be directed to them.
        <br />
        <br />

        <h2 class="h2_text">3.Personal Information Sharing</h2>
        <br />
        <br />
        We do not rent, sell or share your personal information with third
        parties except as disclosed in this Privacy Policy.  
        <br />
        <br />
        We share personal information as follows:
        <br />
        <br />
        <ul class="disc_ul">
          <li>
            Other Hippocrates users. When you allow others to access, use, or
            edit content in your account, we share that content with them. For
            example, if you send an envelope to others for review or signature,
            we make the contents of the envelope available to them.
          </li>
          <li>
            Third Parties. When you make a payment to another user within our
            Services, we share your payment method details with the third-party
            payment processor selected by you or the other user.
          </li>
          <li>
            Your Employer or Organization. When you create an account or user
            role with an email directory assigned to you as an employee,
            contractor or member of an organization , that organization (if it
            is a Hippocrates customer with certain features) can find your
            account and take certain actions that may affect your account.
          </li>
        </ul>
        <br />

        <h2 class="h2_text">4.Retention of Personal Information</h2>
        <br />
        <br />
        We keep your personal information for no longer than necessary for the
        purposes for which it is processed. The length of time for which we
        retain personal information depends on the purposes for which we
        collected and use it and/or as required to comply with applicable laws
        as set out in our data retention policy and information handling
        standards. Where there are technical limitations that prevent deletion
        or anonymization, we safeguard personal information and limit active use
        of it.
        <br />
        <br />

        <h2 class="h2_text">5.Your Choices</h2>
        <br />
        <br />
        This section describes many of the actions you can take to change or
        limit the collection or use of your personal information.
        <br />
        <br />
        <ul class="disc_ul">
          <li>
            Profile. You are not required to fill out a profile. If you do, you
            can access and review this personal information. If any personal
            information is inaccurate or incomplete, you can make changes in
            your account settings.
          </li>
          <li>
            Cookies and Other Related Technology. You can decline cookies
            through your browser settings or via the Hippocrates Cookie
            Preference Center and other methods detailed in our Cookie Notice.
            However, if you decline cookies, you may not be able to use some
            parts of our Services. Please note we do not recognize or respond to
            browser-initiated Do Not Track signals.
          </li>
          <li>
            Complaints. We are committed to resolving valid complaints about
            your privacy and our collection or use of your personal information.
            For questions or complaints regarding our data use practices or
            Privacy Policy, please contact us.
          </li>
        </ul>
        <br />

        <h2 class="h2_text">6.Children's Privacy</h2>
        <br />
        <br />
        Our Services are not designed for and are not marketed to people under
        the age of 16 (“minors”). We do not knowingly collect or ask for
        personal information from minors. We do not knowingly allow minors to
        use our Services. If you are a minor, please do not use our Services or
        send us your personal information. We delete personal information that
        we learn is collected from a minor without verified parental consent.
        Please contact us.
        <br />
        <br />

        <h2 class="h2_text">7.Your Privacy Rights</h2>
        <br />
        <br />
        You may have certain rights related to your personal information,
        subject to local data protection laws.  These rights include: 
        <br />
        <br />
        <ul class="disc_ul">
          <li>
            You can access and review personal information associated with your
            account at any time.
          </li>
          <li>
            You have a right to correct inaccurate personal information about
            you.
          </li>
          <li>
            In certain situations, you can ask that we delete/erase or stop
            using your personal information (and object to use of your personal
            information). 
          </li>
          <li>
            If you are unsatisfied with our response to your complaint, you have
            a right to raise questions or complaints with your local data
            protection authority at any time.
          </li>
        </ul>
        We will take reasonable steps to verify your identity. If you have an
        account with us, we may verify you through your login of your account.
        If you do not have an account with us, we may require you to provide
        additional information from which we can satisfy ourselves of your
        identity. You may authorize an agent to make a request to us on your
        behalf and we will verify the identity of your agent or authorized legal
        representative by either seeking confirmation from you or documents that
        establish the agent’s authorization to act on your behalf.
        <br />
        <br />
        Certain personal information may be exempt from such requests under
        applicable law. We need certain types of personal information so that we
        can provide the product and Services to you. If you ask us to delete it,
        you may no longer be able to access or use our product and Services.
        <br />
        <br />

        <h2 class="h2_text">8.How We Protect Your Personal Information</h2>
        <br />
        <br />
        To keep your personal information safe, we use physical, electronic, and
        managerial tools. We apply these tools based on the sensitivity of the
        personal information we collect, use, and store, and the current state
        of technology. We protect your personal information through technical
        and organizational security measures to minimize risks associated with
        data loss, misuse, unauthorized access, and unauthorized disclosure and
        alteration.
        <br />
        <br />

        <h2 class="h2_text">9.Changes to This Policy</h2>
        <br />
        <br />
        We may amend this Privacy Policy to reflect changes in the law, our
        companies, our Services, our data collection use and practices, or
        advances in technology. Our use of the personal information we collect
        is subject to the Privacy Policy in effect at the time such personal
        information is used. Depending on the type of change, we may notify you
        of the change by posting on this page, adding a banner to
        Hippocrates.com or by email. 
        <br />
        <br />

        <h2 class="h2_text">10.How to Contact Us</h2>
        <br />
        <br />
        For questions or complaints regarding our use of your personal
        information or Privacy Policy, please contact us at<span
          class="uni_color"
        >
          contact@hippocrateshealth.com </span
        >or 400-886-2808 . Attention: 400 Fangchun Road, Shanghai Pilot Free
        Trade Zone.
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  name: "PrivacyAgreementModal",
};
</script>

<style scoped lang="scss">
.content {
  font-size: 14px;
  font-family: $font-weight-5;
  font-weight: 550;
  height: 100%;
  overflow-y: auto;

  .h1_text {
    margin: 0px;
    font-size: 20px;
    text-align: left;
    color: rgb(27, 73, 160);
  }
  .h2_text {
    font-size: 16px;
    text-align: left;
    color: rgb(27, 73, 160);
    border-bottom: none;
  }
  .maoLink li {
    list-style-type: decimal;
    color: rgb(53, 126, 234);
  }
  .disc_ul {
    margin-left: 20px;
  }
  .disc_ul li {
    list-style-type: disc;
  }
  .uni_color {
    color: rgb(53, 126, 234);
  }
}

::v-deep(.el-dialog) {
  overflow: hidden;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}
::v-deep(.el-dialog__header) {
  background: #ffffff;
  box-shadow: 0 1px 8px 0 #ebebeb;
  border-radius: 10px 10px 0 0;
  text-align: center;
}
::v-deep(.el-dialog__title) {
  font-size: 18px;
  font-family: $font-weight-5;
  color: $color;
}
::v-deep(.el-dialog__headerbtn) {
  top: 20px;
}
::v-deep(.el-dialog__body) {
  height: 460px;
}
</style>
